import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Observable, finalize, takeUntil, tap } from 'rxjs';

import {
  CustomResultOfPaginatedListOfGetFormBuilderResponsesByFormBuilderIdDto,
  GetEnumValuesDto,
  GetFormBuilderResponsesByFormBuilderIdDto,
  GetFormBuilderResponsesByIdDto,
} from 'src/app/core/api/models';
import { ExcelService, FormBuildersService } from 'src/app/core/api/services';
import { BaseIndexModule } from 'src/app/pages/shared/base';
import { BaseIndexPageComponent } from 'src/app/pages/shared/base/components/base-index-page.component';
import { FormBuilderResponsesDetailComponent } from './form-builder-responses-detail/form-builder-responses-detail.component';
import { AppDomService } from 'src/app/core/services/dom.service';
import { FormBuilderResponsesExcelDialogComponent } from './form-builder-responses-excel/form-builder-responses-excel-dialog.component';

@Component({
  selector: 'app-form-builder-responses',
  templateUrl: './form-builder-responses.component.html',
  standalone: true,
  imports: [BaseIndexModule, FormBuilderResponsesDetailComponent],
})
export class FormBuilderResponsesComponent
  extends BaseIndexPageComponent
  implements OnInit
{
  pageName = 'formBuilderResponses';

  modelWithPagination$: Observable<CustomResultOfPaginatedListOfGetFormBuilderResponsesByFormBuilderIdDto>;
  items$: Observable<Array<GetFormBuilderResponsesByFormBuilderIdDto>>;
  SmsAggregatorEnumValues: GetEnumValuesDto[] = [];
  isShowResponses: boolean = false;
  responseModel: GetFormBuilderResponsesByIdDto;

  @Input() formBuilderId: any;
  @Output('onBack') output_onBack = new EventEmitter<boolean>();

  constructor(
    protected currentService: FormBuildersService,
    public excelFileService: ExcelService
  ) {
    super();
  }

  ngOnInit() {
    super.ngOnInit();
    this.pageConfig.title = 'common.responses';
    this.pageConfig.showAuditBtn = false;
    this.pageConfig.showAddBtn = false;
    this.pageConfig.showHelpBtn = false;
  }

  configTableColumns() {
    this.tableColumns = [
      {
        title: 'common.mobile',
        name: 'mobile',
        hasSearch: true,
      },
      {
        title: 'common.operators',
        name: 'mobileOperator',
        hasSearch: true,
        type: 'enum',
        enumName: 'SmsAggregator',
      },
      {
        title: this.localizer.createDate,
        name: 'created',
        hasSearch: true,
        type: 'dateTime',
      },
    ];
  }

  getEnumsValues() {
    this.getEnumValuesApi('SmsAggregator')
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((values) => (this.SmsAggregatorEnumValues = values));
  }

  //Get All
  getPaginationApi(): Observable<CustomResultOfPaginatedListOfGetFormBuilderResponsesByFormBuilderIdDto> {
    return this.currentService.formBuildersGetFormBuilderResponsesByFormBuilderId(
      {
        body: {
          ...this.getBaseModelWithPaginationParams(),
          formBuilderId: this.formBuilderId,
        },
      }
    );
  }

  onShowResponses(id) {
    this.unSubs();

    this.loading = true;
    this.currentService
      .formBuildersGetFormBuilderResponsesById({ Id: id })
      .pipe(
        takeUntil(this.onDestroy$),
        finalize(() => (this.loading = false))
      )
      .subscribe((res) => {
        if (res) {
          this.responseModel = res.data;
          this.isShowResponses = true;
        }
      });
  }

  responsesExcelReportApi() {
    this.excelFileService
      .excelCreateFormBuilderResponsesExcelGet()
      .pipe(this.basePipeOperators())
      .subscribe((res) => {
        if (res) {
          let data = {
            title: `${this.pageVocabs}responsesExcel`,
            comparisonObjects: this.comparisonObjects,
            sortObject: this.sortObject,
            formBuilderId: this.formBuilderId,
          };

          const modalResult = this.dialogService.openModal({
            component: FormBuilderResponsesExcelDialogComponent,
            data: data,
          });

          modalResult
            .afterClosed()
            .pipe(
              takeUntil(this.onDestroy$),
              tap(() => {
                AppDomService.removeModalScrollClassFromHtml();
              })
            )
            .subscribe();
        }
      });
  }

  onExcelReport() {
    this.responsesExcelReportApi();
  }

  emitOnBack() {
    this.output_onBack.emit(true);
    this.unSubs();
  }

  onReset() {
    this.getTableData();
  }
}
